// Allow iframes in content to be wrapped in responsive code
import $ from 'jquery';

export default function setupTabs (vars){
	$(".tabs__menu__item").click(function(event) {
        event.preventDefault();
        $(this).addClass("tabs__menu__item--current");
        $(this).siblings().removeClass("tabs__menu__item--current");
        var tab = $(this).find('a').attr("href");
        $(tab).siblings(".tab").not(tab).css("display", "none");
        $(tab).fadeIn();
    });
}